import InlineMessage from '@base/InlineMessage/InlineMessage.component'

import SplitAuthLayout from '../SplitAuthLayout/SplitAuthLayout.component'

interface Props {
  welcome: string
  message: string
  showLanguageSwitcher?: boolean
}

const AuthError = ({ welcome, message, showLanguageSwitcher }: Props) => (
  <SplitAuthLayout
    heading={welcome}
    dataTestId='auth-error'
    showLanguageSwitcher={showLanguageSwitcher}
  >
    <InlineMessage variant='error'>{message}</InlineMessage>
  </SplitAuthLayout>
)

export default AuthError
